<template>
<!-- TODO update to policy columns and data -->
<!--  FYI below is copy-pasted from rowComponent -->
  <tr class="policy-row-component">
    <td v-if="getTableColumnValues.includes('customer')">
      <BadgeComponent v-if="hasCustomer" :customer="mortgage.customer.data"></BadgeComponent>
    </td>
    <td v-if="getTableColumnValues.includes('hypotheeknummer')">
      {{ mortgage.hypotheeknummer }}
    </td>
    <td v-if="getTableColumnValues.includes('onderpandsgegevens')">
      {{ collateral }}
    </td>
    <td v-if="getTableColumnValues.includes('passeerdatum')">
      {{ mortgage.passeerdatum | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('marktwaarde')">
      {{ mortgage.marktwaarde | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('agency_name')">
      {{ mortgage.agency_name }}
    </td>
    <td v-if="getTableColumnValues.includes('company_label_description')">
      {{ mortgage.company_label_description }}
    </td>
    <td v-if="getTableColumnValues.includes('hypotheciareInschrijving')">
      {{ mortgage.hypotheciareInschrijving | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('principal_sum')">
      {{ mortgage.principal_sum | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('remaining_principal_sum')">
      {{ mortgage.remaining_principal_sum | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('remaining_interest_only_sum')">
      {{ mortgage.remaining_interest_only_sum | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('end_financing_reservation_date')">
      {{ mortgage.end_financing_reservation_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('bank_guarantee_date')">
      {{ mortgage.bank_guarantee_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('validity_unsigned_offer_date')">
      {{ mortgage.validity_unsigned_offer_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('validity_signed_offer_date')">
      {{ mortgage.validity_signed_offer_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('final_offer_date')">
      <!-- Offerte ongetekend geldig tot -->
      {{ mortgage.final_offer_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('offer_expire_date')">
      <!-- Offerte getekend geldig tot -->
      {{ mortgage.offer_expire_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('quotation_extend_date')">
      <!-- Geldigheidsduur offerte te verlengen tot -->
      {{ mortgage.quotation_extend_date | toDate }}
    </td>
  </tr>
</template>

<script>
import BadgeComponent from "~/modules/customer/components/BadgeComponent";
import UserBadgeComponent from "~/modules/user/components/BadgeComponent";
import EmailStatusComponent from "~/modules/email/components/EmailStatusComponent";
import TaskBadgeGroupComponent from "~/modules/task/components/TaskBadgeGroupComponent";

const moment = require("moment");

export default {
  name: "PolicyRowComponent",
  props: {
    mortgage: {
      type: Object,
      required: true
    },
    tableColumns: {
      type: Array,
      required: true
    }
  },
  components: {
    BadgeComponent,
    UserBadgeComponent,
    EmailStatusComponent,
    TaskBadgeGroupComponent
  },
  computed: {
    collateral() {
      if (!this.mortgage.onderpandsgegevens) {
        return 'Adres onbekend'
      }
      return this.mortgage.onderpandsgegevens;
    },
    hasCustomer() {
      return typeof this.mortgage.customer_id !== "undefined" && this.mortgage.customer_id !== null && typeof this.mortgage.customer !== "undefined" && this.mortgage.customer !== null && this.mortgage.customer.data !== null;
    },
    getTableColumnValues() {
      return this.tableColumns.map(column => column.value)
    }
  }
};
</script>

<style scoped>
tr td.half-padding {
  padding: 4px;
}

tr.selected {
  background-color: #1890ff1c;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

tr .pencil-icon {
  display: none;
}

tr:hover .pencil-icon {
  display: initial;
}
</style>
